<script>
export default {
    name: 'zendesk',
    mounted() {
        window.zESettings = {
            webWidget: {
                launcher: {
                    badge: {
                        layout: 'text_only',
                        label: {
                            '*': 'Está com dificuldades?',
                        }
                    },
                     chatLabel: {
                        '*': 'Está com dificuldades?'
                     }
                }
            }
        };
        zE(function() {
            $zopim(function() {
                $zopim.livechat.addTags("cpf", sessionStorage.getItem("cpf")); 
                $zopim.livechat.addTags("clinica", sessionStorage.getItem("idclinica")); 
                $zopim.livechat.addTags("empresa", sessionStorage.getItem("empresa")); 
                $zopim.livechat.addTags("origem", sessionStorage.getItem("origem")); 
                $zopim.livechat.addTags("local", "Ativação paciente"); 
                //$zopim.livechat.window.setPosition('bl');
                $zopim.livechat.badge.hide();
            });
        });
    }
}
</script>

